import CommunicationStatusBadge from "./CommunicationStatusBadge";

function formatDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return new Intl.DateTimeFormat("nl-NL", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

export default function CommunicationThreadList({
  threads,
  selectedThreadId,
  onSelect,
  loading = false,
  emptyText = "Nog geen gesprekken.",
}) {
  if (loading) {
    return <div className="rounded-xl border border-slate-200 bg-white p-4 text-sm text-slate-600">Communicatie laden...</div>;
  }

  if (!Array.isArray(threads) || threads.length === 0) {
    return <div className="rounded-xl border border-dashed border-slate-300 bg-white p-6 text-sm text-slate-500">{emptyText}</div>;
  }

  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-200 text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-3 font-medium">Onderwerp</th>
              <th className="px-4 py-3 font-medium">Klant</th>
              <th className="px-4 py-3 font-medium">Project</th>
              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3 font-medium">Laatste bericht</th>
              <th className="px-4 py-3 font-medium">Actiehouder</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {threads.map((thread) => {
              const isSelected = String(selectedThreadId || "") === String(thread?._id || "");
              return (
                <tr
                  key={thread._id}
                  onClick={() => onSelect?.(thread)}
                  className={`cursor-pointer transition hover:bg-slate-50 ${isSelected ? "bg-slate-50" : "bg-white"}`}
                >
                  <td className="px-4 py-3">
                    <div className="flex flex-wrap items-center gap-2">
                      <p className="font-medium text-slate-900">{thread.subject || "Zonder onderwerp"}</p>
                      {thread?.needsInternalAttention ? (
                        <span className="inline-flex items-center rounded-full border border-rose-200 bg-rose-50 px-2 py-0.5 text-[11px] font-semibold text-rose-700">
                          Klantreactie
                        </span>
                      ) : null}
                    </div>
                    <p className="text-xs text-slate-500">{thread.channel || "manual"}</p>
                  </td>
                  <td className="px-4 py-3 text-slate-700">{thread?.clientId?.naam || "-"}</td>
                  <td className="px-4 py-3 text-slate-700">
                    {thread?.projectId?.projectNummer ||
                      thread?.projectId?.number ||
                      thread?.projectId?.naam ||
                      thread?.projectId?.title ||
                      "Niet gekoppeld"}
                  </td>
                  <td className="px-4 py-3">
                    <CommunicationStatusBadge status={thread.status} />
                  </td>
                  <td className="px-4 py-3 text-slate-700">{formatDate(thread.lastMessageAt)}</td>
                  <td className="px-4 py-3 text-slate-700">
                    {thread?.assignedToUserId?.naam || thread?.assignedToRole || "-"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
